
<div class="liner">
  <div class="ttl_form">{{ headerText }}</div>

  <div class="ins_space top">
    <div class="label">
      {{ organizationHeaderText }} <span>*</span>
    </div>

    <select (change)="organizationChangeEvent($event)">
      <option value="" selected="selected"></option>
      <option *ngFor="let organization of filteredOrganizations"
              [selected]="isOrganizationSelected(organization)"
              value="{{ organization.value }}">
        {{ organization.name }}
      </option>
    </select>
  </div>
  
  <div class="ins_space top">
    <div class="label">
      {{ departmentHeaderText }} <span>*</span>
    </div>

    <select (change)="departmentChangeEvent($event)">
      <option value="" selected="selected"></option>
      <option *ngFor="let department of filteredDepartments"
              [selected]="isDepartmentSelected(department)"
              value="{{ department.value }}">
        {{ department.name }}
      </option>
    </select>
  </div>

  <div class="ins_space top">
    <div class="label">{{ divisionHeaderText }}</div>

    <select (change)="divisionChangeEvent($event)">
      <option value="" selected="selected">Все</option>
      <option *ngFor="let division of filteredDivisions"
              [selected]="isDivisionSelected(division)"
              value="{{ division.value }}">
        {{ division.name }}
      </option>
    </select>
  </div>

  <mat-expansion-panel class="org-tree-expansion">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div>
          <div class="title-directory-user-block">
            {{ userBlockHeaderText }}
          </div>
          <div>{{ getSelectedUserBlocksDisplayText() }}</div>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="org-tree-element org-tree-block">
      <mat-tree [dataSource]="dataSource"
                [treeControl]="treeControl">

        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
          <button mat-icon-button disabled></button>
          <mat-checkbox class="checklist-leaf-node"
                        (change)="userBlockChangeEvent($event, node)"
                        [checked]="isUserBlockSelected(node.id)"
                        [indeterminate]="isParentOfSelectedUserBlock(node.id)"
                        [value]="node.id">
            {{ node.name }}
          </mat-checkbox>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: userBlockHasChild" matTreeNodePadding>
          <button mat-icon-button
                  matTreeNodeToggle
                  [attr.aria-label]="'Toggle ' + node.Name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
          <mat-checkbox (change)="userBlockChangeEvent($event, node)"
                        [checked]="isUserBlockSelected(node.id)"
                        [indeterminate]="isParentOfSelectedUserBlock(node.id)"
                        [value]="node.id">
            {{ node.name }}
          </mat-checkbox>
        </mat-tree-node>

      </mat-tree>
    </div>
  </mat-expansion-panel>

  <div mat-dialog-content></div>
</div>
